





import { Vue, Component } from "vue-property-decorator";

import DeliveryList from "@/components/cutomer/mypage/index.vue";

@Component({
  name: "Index",
  components: {
    DeliveryList,
  },
})
export default class Index extends Vue {}
